module.exports = __webpack_public_path__ + "img/body_chart.90c5fefa.png";